import { firebase } from "@/config/firebase.ts";
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";

const app = initializeApp(firebase);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);

// Utility function for logging events
export const logAnalyticsEvent = (
  eventName: string,
  eventParams?: { [key: string]: any },
) => {
  try {
    logEvent(analytics, eventName, eventParams);
  } catch (error) {
    console.error("Error logging analytics event:", error);
  }
};
